import { ColumnDef } from "@tanstack/react-table";

// Helper function
const moneyFormat = (amount: number) => {
	if (!amount && amount !== 0) return "0.00";
	return amount.toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};

// ==================== PAYSLIPS COLUMNS ====================
export const payslipsColumns: ColumnDef<any>[] = [
	{
		accessorKey: "payPeriod",
		header: "Pay Period",
		size: 220,
		minSize: 180,
		maxSize: 300,
		cell: ({ getValue }) => {
			const payPeriod = getValue() as any;
			return payPeriod?.code || "--";
		},
	},
	{
		accessorKey: "basicPayAmount",
		header: "Basic Pay",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "grossAmount",
		header: "Gross Pay",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "netPayAmount",
		header: "Net Pay",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "employeePensionAmount",
		header: "Employee Pension Contribution",
		size: 250,
		minSize: 200,
		maxSize: 350,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "employerPensionAmount",
		header: "Employer Pension Contribution",
		size: 250,
		minSize: 200,
		maxSize: 350,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "taxAmount",
		header: "Income Tax",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "employeeSavingSchemeAmount",
		header: "Employee Saving Scheme Amount",
		size: 280,
		minSize: 220,
		maxSize: 400,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "employerSavingSchemeAmount",
		header: "Employer Saving Scheme Amount",
		size: 280,
		minSize: 220,
		maxSize: 400,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "allowanceAmount",
		header: "Allowance Amount",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "overtimeAmount",
		header: "Overtime Amount",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "bonusAmount",
		header: "Bonus Amount",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "backpayAmount",
		header: "Backpay Amount",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "loanRepaymentAmount",
		header: "Loan Repayment Amount",
		size: 220,
		minSize: 180,
		maxSize: 320,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "partialSalaryAmount",
		header: "Partial Salary Amount",
		size: 220,
		minSize: 180,
		maxSize: 320,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "salaryAdvanceAmount",
		header: "Salary Advance Amount",
		size: 220,
		minSize: 180,
		maxSize: 320,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "unionDeductionsAmount",
		header: "Union Deductions Amount",
		size: 220,
		minSize: 180,
		maxSize: 320,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
];

export const payslipsColumnVisibility = {
	payPeriod: true,
	grossAmount: true,
	basicPayAmount: true,
	netPayAmount: true,
	employeePensionAmount: true,
	employerPensionAmount: true,
	taxAmount: true,
	employeeSavingSchemeAmount: false,
	employerSavingSchemeAmount: false,
	allowanceAmount: false,
	overtimeAmount: false,
	bonusAmount: false,
	backpayAmount: false,
	loanRepaymentAmount: false,
	partialSalaryAmount: false,
	salaryAdvanceAmount: false,
	unionDeductionsAmount: false,
	actions: true,
};

// ==================== RECENT PAY COLUMNS ====================
export const recentPayColumns: ColumnDef<any>[] = [
	{
		accessorKey: "payPeriod",
		header: "Pay Period",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => {
			const payPeriod = getValue() as any;
			return payPeriod?.code || "--";
		},
	},
	{
		accessorKey: "basicPayAmount",
		header: "Basic Pay",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "grossAmount",
		header: "Gross Pay",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "netPayAmount",
		header: "Net Pay",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "employeePensionAmount",
		header: "Employee Pension Contribution",
		size: 250,
		minSize: 200,
		maxSize: 350,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "employerPensionAmount",
		header: "Employer Pension Contribution",
		size: 250,
		minSize: 200,
		maxSize: 350,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "taxAmount",
		header: "Income Tax",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
];
